import React, { useEffect, useRef, useState } from 'react';
import classes from './ViewDropdown.module.scss';
import { useClickAway } from 'utils/hooks/useClickAway';
import { Tooltip } from 'react-bootstrap';

import {
  setCards,
  setDefaultCard,
  setImpactedCards,
  setSelectedView,
} from 'store/home/homeMyViewSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  setSaveInsightViewBtnState,
  setSelectedInsightView,
} from 'store/customer/customerViewSlice';
import {
  BUTTON_STATE,
  COMPONENT_MAPPING,
  CONFIGURE_VIEW,
  VIEW_ACTION_TYPE,
} from 'constants/constants';
import { setCards as setInsightCards } from 'store/customer/customerViewSlice';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import SaveWarningModal from 'components/customer/section-menu/SaveWarningModal';
import { scrollToSelectedView } from 'utils/utils';

const ViewDropdown = ({ viewOptions, selectedView, page }) => {
  const containerRef = useRef();
  const serachInputRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showViewWarningModal, setShowViewWarningModal] = useState(false);
  const [selectedOption, sectSelectedOption] = useState();
  const dispatch = useDispatch();
  const isInsights = page === CONFIGURE_VIEW.insights;
  const ismyDefault = page === CONFIGURE_VIEW.myDefault;
  const selectedInsightView = useSelector(
    (state) => state?.CustomerView?.selectedInsightView
  );
  const saveInsightViewBtnState = useSelector(
    (state) => state?.CustomerView?.saveInsightViewBtnState
  );

  const onViewChangeHandler = (option) => {
    sectSelectedOption(option);
    if (isInsights && selectedInsightView.Id !== option.Id) {
      if (!saveInsightViewBtnState) {
        setShowViewWarningModal(!showViewWarningModal);
        return;
      }

      // 1. Avoid multiple api call on view change and previous view all tiles are loaded, so to resolve this issues scroll to top on view change
      // 2. Avoid auto stiky behavior of sections menus on page load.
      scrollToSelectedView(COMPONENT_MAPPING.Insights);

      dispatch(setSelectedInsightView(option));
      dispatch(setInsightCards([]));
    } else if (selectedView?.Id !== option?.Id) {
      dispatch(setCards([]));
      dispatch(setDefaultCard([]));
      dispatch(setImpactedCards([]));
      dispatch(setSelectedView(option));
    }
    setIsOpen(false);
  };

  const onProceed = () => {
    setShowViewWarningModal(false);
    if (isInsights && selectedInsightView?.Id !== selectedOption?.Id) {
      // Avoid multiple get cardsapi call for next set of pagination on view change.
      scrollToSelectedView(COMPONENT_MAPPING.Insights);

      dispatch(setSaveInsightViewBtnState(BUTTON_STATE.DISABLED));
      dispatch(setSelectedInsightView(selectedOption));
    }
  };

  useClickAway(containerRef, () => {
    setIsOpen(false);
  });

  const filteredOptions = viewOptions?.filter((option) =>
    option?.name?.toLowerCase()?.includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    if (isOpen && serachInputRef.current) {
      serachInputRef.current.focus();
    }
  }, [isOpen]);

  const onCancel = () => {
    setShowViewWarningModal(false);
  };

  return (
    <div className='position-relative d-inline-block w-auto mw-100'>
      <OverlayTrigger
        overlay={
          <Tooltip className='gne-tooltip'>{selectedView?.name}</Tooltip>
        }>
        <div
          className={`d-flex align-items-baseline ${!isInsights ? 'me-2' : ''} ${classes?.['view-text']} w-auto mw-100`}
          onClick={() => setIsOpen(!isOpen)}>
          <span className={` ${classes?.ellipses} `}>{selectedView?.name}</span>
          <i className='icon icon__chevron-down-gray' />
        </div>
      </OverlayTrigger>

      {isOpen && (
        <div
          ref={containerRef}
          className={`${classes['view-popup']} `}>
          <div className='position-relative px-3 py-2 d-flex align-items-center border-bottom'>
            <i
              className={`icon icon__search ${classes['view-serach-icon']}`}></i>
            <input
              ref={serachInputRef}
              type='search'
              placeholder=' Search'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={classes['view-search-input']}
            />
          </div>
          <ul className={classes['view-list-container']}>
            {filteredOptions?.map((option, index) => (
              <li
                key={index}
                onClick={() => onViewChangeHandler(option)}
                className={`${classes['view-list']} px-3 py-2 ${
                  selectedView.Id === option.Id
                    ? classes['selected-option']
                    : ''
                }`}>
                <p
                  className={`${classes.ellipses} p-0 m-0 text text__small w-auto mw-100`}>
                  {option.name}
                </p>
                <span className='p-0 m-0 text__x-small text__grey'>
                  {option?.owner}
                  {ismyDefault ? ` (${option?.roleId})` : ''}
                </span>
              </li>
            ))}

            {filteredOptions?.length === 0 && (
              <li className={`${classes['view-list']} px-3 py-3`}>
                <p
                  className={`${classes.ellipses} p-0 m-0 text text__small text-center text__grey`}>
                  No options
                </p>
              </li>
            )}
          </ul>
        </div>
      )}
      <SaveWarningModal
        show={showViewWarningModal}
        onProceed={onProceed}
        viewActionType={VIEW_ACTION_TYPE.CHANGE_VIEW}
        onHide={onCancel}
      />
    </div>
  );
};

export default ViewDropdown;
